type HasTeam = {
  team?: { id: number } | null;
};

export const filterPatientsByTeam = <T extends HasTeam>({
  patients,
  selectedTeams,
  allTeamsSelected,
}: {
  patients: T[];
  selectedTeams: ReadonlySet<number>;
  allTeamsSelected: boolean;
}): T[] => {
  if (allTeamsSelected) {
    return patients;
  }
  return patients.filter(
    (patient) =>
      patient.team !== null &&
      patient.team !== undefined &&
      selectedTeams.has(patient.team.id),
  );
};
